"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TripTrackingIssue = void 0;
var TripTrackingIssue;
(function (TripTrackingIssue) {
    TripTrackingIssue["PickupTooFar"] = "PickupTooFar";
    TripTrackingIssue["TrackingNotStartedOnTime"] = "TrackingNotStartedOnTime";
    TripTrackingIssue["DropoffTooLate"] = "DropoffTooLate";
    TripTrackingIssue["HasTrackingGaps"] = "HasTrackingGaps";
    TripTrackingIssue["ArrivalAtStopTooLate"] = "ArrivalAtStopTooLate";
})(TripTrackingIssue || (exports.TripTrackingIssue = TripTrackingIssue = {}));
//# sourceMappingURL=TripTrackingIssue.enum.js.map